import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n'

Vue.config.productionTip = false

import { VueMaskDirective } from 'v-mask'
import axios from "axios";
Vue.directive('mask', VueMaskDirective);

process.env.NODE_ENV === 'production'
    ? axios.defaults.withCredentials = true
    : axios.defaults.withCredentials = false;

fetch(process.env.BASE_URL + "appsettings.json")
  .then((json) => {
    json.json().then((config) => {
       Vue.prototype.$config = config
       new Vue({
        vuetify,
        i18n,
        render: h => h(App),
      }).$mount('#app')
    })
})
